// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__2i_jX","approved":"Status_approved__3Tsq0","rejected":"Status_rejected__VIjju","expired":"Status_expired__3sjao","label":"Status_label__1Frjf"};